import { Dispatch } from 'redux'
import * as api from 'redux/api/OrganizationalUnits'
import { toggleSnackbarOpen } from 'redux/actions/Snackbar'
import {
  TOrganizationalUnitCreateRequest,
  TOrganizationalUnitUpdateRequest
} from 'types/GlobalOrganizationalUnit'
import { useThunkActions } from 'redux/actions/useThunkActions'
import { SnackbarMessage } from 'types/GlobalSnackbar'

import * as actions from './actions'

/**
 * Fetch all organizational units
 */
export function tryGetOrganizationalUnits() {
  return (dispatch: Dispatch) => {
    dispatch(actions.getAll())

    api
      .getOrganizationalUnits()
      .then((response) => {
        dispatch(actions.getAllSuccess(response))
      })
      .catch(() => {
        dispatch(actions.getAllFailed())
      })
  }
}

/**
 * Create a new organizational unit
 */
export function tryCreateOrganizationalUnit(
  data: TOrganizationalUnitCreateRequest
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.create())

    api
      .tryCreateOrganizationalUnit(data)
      .then((response) => {
        dispatch(actions.createSuccess(response))

        dispatch(toggleSnackbarOpen(SnackbarMessage.OrganizationalUnitCreated))
      })
      .catch(() => {
        dispatch(actions.createFailed())

        dispatch(
          toggleSnackbarOpen(SnackbarMessage.OrganizationalUnitCreatedFailed)
        )
      })
  }
}
/**
 * Update an organizational unit
 */
export function tryUpdateOrganizationalUnit(
  id: string,
  data: TOrganizationalUnitUpdateRequest
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.update())

    api
      .tryUpdateOrganizationalUnit(id, data)
      .then((response) => {
        dispatch(actions.updateSuccess(response))

        dispatch(toggleSnackbarOpen(SnackbarMessage.OrganizationalUnitUpdated))
      })
      .catch(() => {
        dispatch(actions.updateFailed())

        dispatch(
          toggleSnackbarOpen(SnackbarMessage.OrganizationalUnitUpdatedFailed)
        )
      })
  }
}
/**
 * Delete an organizational unit
 */
export function tryDeleteOrganizationalUnit(id: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.destroy())

    api
      .tryDeleteOrganizationalUnit(id)
      .then(() => {
        dispatch(actions.destroySuccess(id))

        dispatch(toggleSnackbarOpen(SnackbarMessage.OrganizationalUnitDeleted))
      })
      .catch(() => {
        dispatch(actions.destroyFailed())

        dispatch(
          toggleSnackbarOpen(SnackbarMessage.OrganizationalUnitDeletedFailed)
        )
      })
  }
}

export const useOrganizationalUnitActions = () => {
  return {
    tryGetOrganizationalUnits: useThunkActions(tryGetOrganizationalUnits),
    tryCreateOrganizationalUnit: useThunkActions(tryCreateOrganizationalUnit),
    tryUpdateOrganizationalUnit: useThunkActions(tryUpdateOrganizationalUnit),
    tryDeleteOrganizationalUnit: useThunkActions(tryDeleteOrganizationalUnit)
  }
}
